export const HIDE_SCROLLBAR = {
  '&::-webkit-scrollbar': {
    display: 'none !important'
  },
  '&': {
    scrollbarWidth: 'none !important'
  }
};

export const HIDE_DATE_INPUT_CALENDAR = {
  '::-webkit-calendar-picker-indicator': {
    display: 'none'
  }
};
